var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScheduleTelevisit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 124,
    viewBox: "0 0 123 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.332,
    y: 25,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#82D1EE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_26891_75063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.707 58.6875C40.707 59.8477 41.6094 60.75 42.7695 60.75H57.8945C59.0117 60.75 59.957 59.8477 59.957 58.6875V47H40.707V58.6875ZM54.457 50.2656C54.457 50.0078 54.6719 49.75 54.9727 49.75H56.6914C56.9492 49.75 57.207 50.0078 57.207 50.2656V51.9844C57.207 52.2852 56.9492 52.5 56.6914 52.5H54.9727C54.6719 52.5 54.457 52.2852 54.457 51.9844V50.2656ZM54.457 55.7656C54.457 55.5078 54.6719 55.25 54.9727 55.25H56.6914C56.9492 55.25 57.207 55.5078 57.207 55.7656V57.4844C57.207 57.7852 56.9492 58 56.6914 58H54.9727C54.6719 58 54.457 57.7852 54.457 57.4844V55.7656ZM48.957 50.2656C48.957 50.0078 49.1719 49.75 49.4727 49.75H51.1914C51.4492 49.75 51.707 50.0078 51.707 50.2656V51.9844C51.707 52.2852 51.4492 52.5 51.1914 52.5H49.4727C49.1719 52.5 48.957 52.2852 48.957 51.9844V50.2656ZM48.957 55.7656C48.957 55.5078 49.1719 55.25 49.4727 55.25H51.1914C51.4492 55.25 51.707 55.5078 51.707 55.7656V57.4844C51.707 57.7852 51.4492 58 51.1914 58H49.4727C49.1719 58 48.957 57.7852 48.957 57.4844V55.7656ZM43.457 50.2656C43.457 50.0078 43.6719 49.75 43.9727 49.75H45.6914C45.9492 49.75 46.207 50.0078 46.207 50.2656V51.9844C46.207 52.2852 45.9492 52.5 45.6914 52.5H43.9727C43.6719 52.5 43.457 52.2852 43.457 51.9844V50.2656ZM43.457 55.7656C43.457 55.5078 43.6719 55.25 43.9727 55.25H45.6914C45.9492 55.25 46.207 55.5078 46.207 55.7656V57.4844C46.207 57.7852 45.9492 58 45.6914 58H43.9727C43.6719 58 43.457 57.7852 43.457 57.4844V55.7656ZM57.8945 41.5H55.832V39.4375C55.832 39.0938 55.4883 38.75 55.1445 38.75H53.7695C53.3828 38.75 53.082 39.0938 53.082 39.4375V41.5H47.582V39.4375C47.582 39.0938 47.2383 38.75 46.8945 38.75H45.5195C45.1328 38.75 44.832 39.0938 44.832 39.4375V41.5H42.7695C41.6094 41.5 40.707 42.4453 40.707 43.5625V45.625H59.957V43.5625C59.957 42.4453 59.0117 41.5 57.8945 41.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_26891_75063",
    x: -21.793,
    y: -23.75,
    width: 144.25,
    height: 147,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 31.25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.329412 0 0 0 0 0.529412 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26891_75063"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26891_75063",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleTelevisit);
export default __webpack_public_path__ + "static/media/schedule-televisit.b820af09.svg";
export { ForwardRef as ReactComponent };